import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AuthContext = /*#__PURE__*/createContext(null);
export const ProvideAuthContext = ({
  hasScope,
  children
}) => {
  const value = useMemo(() => ({
    hasScope
  }), [hasScope]);
  return /*#__PURE__*/_jsx(AuthContext.Provider, {
    value: value,
    children: children
  });
};
export const useAuthContext = () => useContext(AuthContext);